/*
  RESADE Einwilligungs-Lader, Teil 2 (05 Abschnitt 8.5, E-19).
  Consent-Mode-Vorgabe und Start des Containers stehen seit 05.10.2026 fest ganz oben im Kopf (layout/theme.liquid,
  Block "Google Tag Manager (Stape)"), der Puffer (Teil 1) inline in snippets/rs-consent.liquid.

  Entscheidung Denny 05.10.2026: Der GTM-Container (Stape-Lader auf privacy.resade.de) laedt bei jedem Besucher
  sofort im head, ohne auf die Einwilligung zu warten. Der Banner bleibt, der Consent Mode meldet die echte Wahl.
  Das Rechtsrisiko (§ 25 TDDDG) ist Denny bekannt (Akte docs/resade/lpv-ladekette-2026-10-04.md, Abschnitt
  "Nicht machen"), er traegt es.

  Ablauf:
  0. Start: Der Block oben im Kopf (layout/theme.liquid) startet den Container und setzt window.rsGtmGestartet; dann
     laedt dieses Skript ihn nicht noch einmal. Fehlt der Start (alte Fassung des Kopfs, etwa aus einem Cache, oder
     ein Push nur dieser Datei), laedt es ihn sofort, ohne Bedingung, genau einmal, wie im alten Theme auch im
     Theme-Editor.
  1. Entscheidungen aus dem Puffer uebernehmen (falls der Banner schneller war).
  2. Den aktuellen Stand ueber Shopifys Customer Privacy API lesen
     (Shopify.loadFeatures 'consent-tracking-api'; Rueckfall ueber das Ereignis
     consentTrackingApiLoaded, LPV-Runde 04.10.2026).
  3. Auf das Ereignis visitorConsentCollected hoeren (neue Wahl im Banner).
  4. Cookie-Banner von Shopify: Knopffolge Akzeptieren, Ablehnen, Praeferenzen, Name ohne Titel,
     erster Tab (Abschnitt 4 unten, E-177). Nur Reihenfolge und ARIA.
  5. Platz unter dem Fuss, solange der Banner steht (Abschnitt 5 unten, Rückmeldung 02.10.2026).
  6. Klick auf „Akzeptieren“ oder „Alle akzeptieren“ sofort anwenden, ohne auf Shopifys
     Serverantwort zu warten (Abschnitt 6 unten, 03.10.2026).
  Jede Entscheidung aktualisiert den Consent Mode, arbeitet die Warteliste ab (wenn) und meldet rs:einwilligung.
  Den Container laedt sie seit 05.10.2026 nicht mehr, er laeuft schon. Mit dem Container kommt genau einmal ein
  Preload fuer Metas fbevents.js (im Kopf, beim Rueckfall in gtmLaden), unabhaengig von der Wahl.
  Die Meta-, Pinterest- und Stape-Tags im Container pruefen die Einwilligung nicht selbst; mit dem Start fuer jeden
  feuern sie deshalb bei jedem Besucher, auch nach „Ablehnen“.
  Kein noscript-iframe.

  Schnittstellen fuer andere rs-Dateien:
  - window.rsEinwilligung.stand() gibt { entschieden, werbung, messung, praeferenzen } zurueck
  - window.rsEinwilligung.wenn('werbung' | 'messung' | 'praeferenzen', fn) ruft fn einmal,
    sobald diese Einwilligung vorliegt (sofort, wenn sie schon vorliegt). Fuer Klaviyo
    (rs-newsletter): Laden erst bei 'werbung' (Marketing-Einwilligung).
  - Ereignis 'rs:einwilligung' an document, detail wie stand(); nur intern, nie fuer Tracking.
  - Jedes Element mit dem Attribut data-rs-cookie-einstellungen oeffnet per Klick die
    Einstellungen des Shopify-Cookie-Banners (window.privacyBanner.showPreferences()).
    Fehlt der Banner, passiert beim Knopf nichts und ein Link folgt seinem href.
  - Aus dem Kopf (layout/theme.liquid): window.rsGtmQuelle (Adresse des Stape-Laders, einzige Quelle) und
    window.rsGtmGestartet (der Container laeuft).

  Stape-App ab 05.10.2026: "Insert GTM" an, "Customer Privacy API" aus (stellt Denny in der App um; ersetzt die
  Entscheidung vom 02.10.2026). Ihr Lader wartet dann ebenfalls nicht auf die Einwilligung; der Container laedt
  doppelt und laeuft einmal (GTM ignoriert den zweiten Start, ein PageView je Seite; Akte, Pruefung 04.10.2026).
*/
(function () {
  'use strict';

  // Adresse des Stape-Laders (Werte aus dem Arbeits-Theme, 23.09.2026). Einzige Quelle ist seit 05.10.2026
  // window.rsGtmQuelle aus dem Kopf (layout/theme.liquid); der Wert hier ist der Rueckfall fuer eine Fassung ohne
  // diesen Block und muss gleich bleiben (geprueft in tools/relaunch/rs-stape-immer.test.mjs).
  var GTM_QUELLE = (typeof window.rsGtmQuelle === 'string' && window.rsGtmQuelle) ||
    'https://privacy.resade.de/8cohtacfhtpy.js?ahp7=EBRJLzIuTDpKNDMwXikyUg9NRkZXRQUaRAIRGwcHBFodFQ%3D%3D';
  // LPV-Runde 04.10.2026: genau die Adresse, die Metas Vorlage im Container per injectScript laedt (Preload im Kopf,
  // beim Rueckfall in gtmLaden). Aendert sich die Meta-Vorlage im Container (andere Adresse, pausiert, serverseitig),
  // hier und im Kopf (layout/theme.liquid) mitziehen oder entfernen.
  var META_SKRIPT = 'https://connect.facebook.net/en_US/fbevents.js';

  // Entscheidung Denny 05.10.2026: Hat der Kopf den Container schon gestartet, startet dieses Skript ihn nie.
  var gtmGeladen = !!window.rsGtmGestartet;
  // Consent-Mode-Vorgabe wie im Block im Kopf; nur fuer den Rueckfall in gtmLaden, wenn dort keine Vorgabe steht
  var VORGABE = {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'granted',
    security_storage: 'granted',
    wait_for_update: 500
  };
  var stand = { entschieden: false, werbung: false, messung: false, praeferenzen: false };
  var warteliste = [];

  function gtagSenden() {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag === 'function') {
      window.gtag.apply(window, arguments);
    } else {
      window.dataLayer.push(arguments);
    }
  }

  // Startet den Container ueber den Stape-Lader, genau einmal je Seite. Seit 05.10.2026 nur noch der Rueckfall fuer den
  // Start unten (Abschnitt 0), wenn der Kopf ihn nicht gestartet hat; eine Wahl im Banner ruft es nicht mehr.
  function gtmLaden() {
    if (gtmGeladen) { return; }
    gtmGeladen = true;
    window.rsGtmGestartet = true;
    window.dataLayer = window.dataLayer || [];
    // Gegenpruefung 05.10.2026: Fehlt der Block im Kopf (etwa nach einem Push einer alten theme.liquid), fehlt auch die
    // Consent-Mode-Vorgabe, die seit 05.10.2026 dort steht. Ohne sie liefen Googles Tags bis zum ersten Update wie
    // "granted". Deshalb hier dieselbe Vorgabe vor gtm.js, wenn noch keine im dataLayer steht.
    if (!vorgabeDa()) { gtagSenden('consent', 'default', VORGABE); }
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    try {
      var skript = document.createElement('script');
      skript.async = true;
      skript.src = GTM_QUELLE;
      var erstes = document.getElementsByTagName('script')[0];
      if (erstes && erstes.parentNode) {
        erstes.parentNode.insertBefore(skript, erstes);
      } else {
        document.head.appendChild(skript);
      }
    } catch (fehler) {
      // ohne DOM zum Einhaengen (sehr alter Browser, Nachbildung im Test) laeuft der Rest dieses Skripts weiter
      return;
    }
    // LPV-Runde 04.10.2026 (Akte docs/resade/lpv-ladekette-2026-10-04.md): fbevents.js gleich mit dem Container
    // vorladen. Metas Vorlage im Container (__cvt_KFNBV, v5) holt die Datei sonst erst, wenn der Container geladen ist
    // und lief; im Pruefstand kam der PageView so 0,28 bis 0,37 s frueher, auf voller Leitung bringt es kaum etwas.
    // Ohne crossorigin wie injectScript, sonst nutzt der Browser den Preload nicht. Seit 05.10.2026 unabhaengig von der
    // Wahl und genau einmal je Seite: mit dem Start im Kopf, sonst hier (gtmGeladen sperrt jeden zweiten Aufruf).
    // Ladezeit Runde 3 (12.10.2026): mit niedriger Prioritaet wie im Kopf, damit er CSS und erstes Bild nicht ausbremst.
    try {
      var vorladen = document.createElement('link');
      vorladen.rel = 'preload';
      vorladen.as = 'script';
      vorladen.href = META_SKRIPT;
      vorladen.fetchPriority = 'low';
      document.head.appendChild(vorladen);
    } catch (fehler) { /* ohne Preload laedt der Container fbevents.js selbst */ }
  }

  function vorgabeDa() {
    var dl = window.dataLayer || [];
    for (var i = 0; i < dl.length; i++) {
      if (dl[i] && dl[i][0] === 'consent' && dl[i][1] === 'default') { return true; }
    }
    return false;
  }

  function kopie() {
    return {
      entschieden: stand.entschieden,
      werbung: stand.werbung,
      messung: stand.messung,
      praeferenzen: stand.praeferenzen
    };
  }

  function wartelisteAbarbeiten() {
    var offen = [];
    for (var i = 0; i < warteliste.length; i++) {
      var eintrag = warteliste[i];
      if (stand[eintrag.art]) {
        try { eintrag.fn(kopie()); } catch (fehler) { /* ein Fehler in einem Abnehmer darf den Rest nicht aufhalten */ }
      } else {
        offen.push(eintrag);
      }
    }
    warteliste = offen;
  }

  function anwenden(werbung, messung, praeferenzen, entschieden) {
    stand.werbung = !!werbung;
    stand.messung = !!messung;
    stand.praeferenzen = !!praeferenzen;
    stand.entschieden = stand.entschieden || !!entschieden;

    gtagSenden('consent', 'update', {
      ad_storage: stand.werbung ? 'granted' : 'denied',
      ad_user_data: stand.werbung ? 'granted' : 'denied',
      ad_personalization: stand.werbung ? 'granted' : 'denied',
      analytics_storage: stand.messung ? 'granted' : 'denied'
    });

    // Seit 05.10.2026 laedt eine Wahl den Container nicht mehr, er laeuft schon (Abschnitt 0).
    wartelisteAbarbeiten();

    try {
      document.dispatchEvent(new CustomEvent('rs:einwilligung', { detail: kopie() }));
    } catch (fehler) { /* sehr alte Browser ohne CustomEvent: nur der Stand zaehlt */ }
  }

  function ausEreignis(detail) {
    detail = detail || {};
    anwenden(detail.marketingAllowed, detail.analyticsAllowed, detail.preferencesAllowed, true);
  }

  function standLesen() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp) { return; }
    try {
      var entschieden = false;
      if (typeof cp.currentVisitorConsent === 'function') {
        var aktuell = cp.currentVisitorConsent() || {};
        entschieden = aktuell.marketing === 'yes' || aktuell.marketing === 'no' ||
          aktuell.analytics === 'yes' || aktuell.analytics === 'no';
      }
      // Abschnitt 6 (03.10.2026): Kennt die Schnittstelle noch keine Wahl, haben Klick oder Ereignis aber schon
      // entschieden (ihr Rueckruf kam in der Serverrunde nach dem Klick), bleibt deren Stand. Sonst sprang der
      // Consent Mode nach granted kurz auf denied.
      if (!entschieden && stand.entschieden) { return; }
      anwenden(
        typeof cp.marketingAllowed === 'function' ? cp.marketingAllowed() : false,
        typeof cp.analyticsProcessingAllowed === 'function' ? cp.analyticsProcessingAllowed() : false,
        typeof cp.preferencesProcessingAllowed === 'function' ? cp.preferencesProcessingAllowed() : false,
        entschieden
      );
    } catch (fehler) { /* API nicht bereit: es bleibt bei "abgelehnt" */ }
  }

  function apiLaden() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') { return false; }
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (fehler) {
      if (!fehler) { standLesen(); }
    });
    return true;
  }

  // Oeffentliche Schnittstelle
  window.rsEinwilligung = {
    stand: kopie,
    wenn: function (art, fn) {
      if (typeof fn !== 'function' || !(art in stand) || art === 'entschieden') { return; }
      warteliste.push({ art: art, fn: fn });
      if (stand[art]) { wartelisteAbarbeiten(); }
    }
  };

  // 0. Start (Entscheidung Denny 05.10.2026): Fehlt der Start aus dem Kopf (layout/theme.liquid), laedt der Container
  //    hier sofort, ohne Bedingung und vor jeder Wahl, auch im Theme-Editor. gtmLaden laedt nur einmal.
  if (!gtmGeladen) { gtmLaden(); }

  // 1. Gepufferte Entscheidungen aus Teil 1 uebernehmen, dann selbst zuhoeren
  var puffer = window.rsEinwilligungPuffer || [];
  window.rsEinwilligungPuffer = null;
  document.addEventListener('visitorConsentCollected', function (e) { ausEreignis(e.detail); });
  for (var i = 0; i < puffer.length; i++) { ausEreignis(puffer[i]); }

  // 2. Aktuellen Stand lesen (Shopify.loadFeatures kommt aus content_for_header)
  if (!apiLaden()) {
    document.addEventListener('DOMContentLoaded', apiLaden, { once: true });
  }
  //    Rueckfall (LPV-Runde 04.10.2026, Akte docs/resade/lpv-ladekette-2026-10-04.md, Nebenbefund 6): Meldet
  //    loadFeatures einen Fehler, weil eine andere Fassung der Schnittstelle laedt (eine andere App hat vorher
  //    Version 0.2 angefordert), las niemand den Stand. Bis 05.10.2026 hiess das: kein Container fuer Wiederkehrer;
  //    seitdem: kein Consent-Update, kein Klaviyo, kein rs:einwilligung. Shopifys Schnittstelle meldet jedes Laden mit
  //    dem Ereignis consentTrackingApiLoaded an document, gleich wer sie angefordert hat. Laedt gar kein Modul, kommt
  //    auch kein Ereignis; dafuer gibt es keinen Rueckfall. War sie schon vor diesem Skript da, ist das Ereignis
  //    vorbei; dann liest der Start sie direkt, aber nur mit Methoden: Shopifys Banner legt vorher ein Teilobjekt ohne
  //    Methoden an (serverTimingSupportVerified, cachedConsent). Kommen Ereignis und Rueckruf beide, liest standLesen
  //    denselben Stand zweimal (ein zweites, gleiches Consent-Update), und eine Wahl aus Klick oder Ereignis bleibt,
  //    solange die Schnittstelle keine kennt (Abschnitt 6).
  document.addEventListener('consentTrackingApiLoaded', standLesen);
  if (window.Shopify && window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.currentVisitorConsent === 'function') { standLesen(); }

  // 3. Knoepfe mit data-rs-cookie-einstellungen: Kasten oben auf Cookie-Richtlinie und Datenschutzerklaerung
  //    (sections/rs-recht-cookie.liquid). Im Fuss steht seit der Rückmeldung 02.10.2026 kein eigener Knopf dafuer.
  document.addEventListener('click', function (e) {
    var ziel = e.target && e.target.closest ? e.target.closest('[data-rs-cookie-einstellungen]') : null;
    if (!ziel) { return; }
    var banner = window.privacyBanner;
    if (banner && typeof banner.showPreferences === 'function') {
      e.preventDefault();
      try { banner.showPreferences(); } catch (fehler) { /* Banner nicht bereit */ }
    }
  });

  // 4. Cookie-Banner von Shopify (E-177, Denny 29.09.2026): Knopffolge Akzeptieren, Ablehnen,
  //    Praeferenzen, Name ohne Titel, erster Tab. Nur Reihenfolge und ARIA, kein Eingriff in die
  //    Zustimmung. Befund aus Shopifys storefront-banner.js:
  //    - Der Banner kommt fertig gebaut als erstes Kind in <body> und wird bei jedem
  //      privacyBanner.showPreferences() entfernt und neu gebaut. Deshalb beobachten wir dauerhaft die
  //      direkten Kinder von <body> (childList, ohne subtree); die eigenen Aenderungen liegen tiefer
  //      oder sind Attribute und loesen den Beobachter nicht erneut aus.
  //    - Die Klicks haengen per addEventListener direkt an den Knoepfen; appendChild verschiebt denselben
  //      Knoten, die Klicks bleiben.
  //    - Erst nach dem Umstellen kommt die Klasse rs-banner-geordnet, an der die neue Anordnung in
  //      rs-cookie.css haengt. Fehlt ein Teil, bleibt alles wie von Shopify geliefert.
  //    - rs-cookie.css muss order: 0 an den Knoepfen behalten: Shopify sortiert unter 480 px per
  //      :nth-child um, nach dem Verschieben stuende sonst Ablehnen vorn.
  //    - Ladezeit Runde 3 (12.10.2026): Folge und die zwei Klassen setzt schon ein Inline-Skript in
  //      snippets/rs-consent.liquid, bevor der Banner zum ersten Mal gezeichnet wird (vorher Layoutsprung 0,082).
  //      bannerOrdnen findet ihn dann geordnet vor und ergaenzt Name, Beschreibung und Platz; es bleibt der Weg fuer
  //      jeden Neubau und der Rueckfall, wenn das Inline-Skript nicht lief.
  var BANNER_ID = 'shopify-pc__banner';
  var BANNER_TITEL_ID = 'shopify-pc__banner__body-title';
  var KNOPF_JA_ID = 'shopify-pc__banner__btn-accept';
  var KNOPF_WAHL_ID = 'shopify-pc__banner__btn-manage-prefs';

  // 5. Platz unter dem Fuss (Rückmeldung 02.10.2026): Der Knopf „Vertrag widerrufen“ steht am Ende der Spalte
  //    „Rechtliches“ und darf am Handy nicht unter dem Banner liegen (§ 356a BGB, leicht zugaenglich). Die verdeckte
  //    Hoehe (Fensterhoehe minus Oberkante des Banners) kommt als --rs-banner-platz an .rs-fuss, nie an html (E-187);
  //    rs-fuss.css rechnet sie zum Abstand unten. Ohne Banner oder nach der Wahl (display: none) 0 px.
  //    Ein ResizeObserver auf dem Banner meldet Groessenwechsel und das Ausblenden, animationend das Ende eines
  //    Einblendens. bannerOrdnen() ruft am Ende platzBeobachten() und haengt den Beobachter so an jeden frisch
  //    gebauten Banner. Der Beobachter wird hier angelegt, vor dem ersten Aufruf beim Laden (unten bei
  //    bannerBeobachten). Fehlt etwas (alter Browser, Nachbildung im Test), bleibt alles wie ohne Skript; ein Fehler
  //    hier haelt die Anordnung des Banners nie auf.
  //    Ladezeit-Runde 03.10.2026 (D1): Einen frisch aufgetauchten Banner misst platzBeobachten nicht mehr sofort (das
  //    erzwang bei jedem Erstbesuch 12 bis 14 ms Layout), sondern der erste Aufruf des ResizeObservers, der nach dem
  //    Layout laeuft. Meldet er nichts (Banner beim Einhaengen ohne Groesse, etwa verborgen), misst ein Nachzuegler
  //    nach zwei Bildern. Ist der Banner weg, gilt 0 px ohne Messung; ohne ResizeObserver misst der Aufruf sofort.
  var platzBanner = null;
  var platzRo = null;
  // D1: wahr, solange ein frisch beobachteter Banner auf seine erste Messung wartet
  var platzOffen = false;
  try {
    if (typeof window.ResizeObserver === 'function') { platzRo = new window.ResizeObserver(fussPlatz); }
  } catch (fehler) { platzRo = null; }

  function fussPlatz() {
    platzOffen = false;
    if (typeof document.querySelector !== 'function') { return; }
    var fuss = document.querySelector('.rs-fuss');
    if (!fuss || !fuss.style || typeof fuss.style.setProperty !== 'function') { return; }
    var banner = document.getElementById(BANNER_ID);
    var platz = 0;
    if (banner && typeof banner.getClientRects === 'function' && banner.getClientRects().length) {
      platz = Math.max(0, Math.ceil(window.innerHeight - banner.getBoundingClientRect().top));
    }
    var wert = platz + 'px';
    var gesetzt = fuss.style.getPropertyValue('--rs-banner-platz');
    // nur schreiben, wenn sich etwas aendert; 0 px ohne gesetzten Wert ist schon der Rueckfall im CSS
    if (gesetzt === wert || (!gesetzt && platz === 0)) { return; }
    fuss.style.setProperty('--rs-banner-platz', wert);
  }

  // D1: Nachzuegler nach zwei Bildern; der erste ResizeObserver-Aufruf kommt im ersten Bild und nimmt ihm die Arbeit ab
  function platzNachzuegler() {
    var messen = function () { if (platzOffen) { fussPlatz(); } };
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(function () { window.requestAnimationFrame(messen); });
    } else {
      setTimeout(messen, 50);
    }
  }

  function platzBeobachten() {
    try {
      var banner = document.getElementById(BANNER_ID);
      var neu = banner !== platzBanner;
      if (neu) {
        if (platzRo && platzBanner) { platzRo.unobserve(platzBanner); }
        if (banner) {
          if (platzRo) { platzRo.observe(banner); }
          if (typeof banner.addEventListener === 'function') { banner.addEventListener('animationend', fussPlatz); }
        }
        platzBanner = banner;
      }
      // Gegenpruefung 02.10.2026: Bleibt der Banner derselbe, meldet der ResizeObserver jede Aenderung selbst; eine
      // Messung bei jeder Aenderung an body kostete ein erzwungenes Layout. Ohne ResizeObserver misst dieser Aufruf.
      // D1: Ein frisch beobachteter Banner wartet auf den ersten ResizeObserver-Aufruf (oder den Nachzuegler); ist der
      // Banner weg, liest fussPlatz kein Layout und schreibt 0 px.
      if (!platzRo) { fussPlatz(); }
      else if (neu) {
        if (banner) { platzOffen = true; platzNachzuegler(); } else { fussPlatz(); }
      }
    } catch (fehler) { /* Messung darf die Anordnung des Banners nie aufhalten */ }
  }

  function bannerOrdnen() {
    var banner = document.getElementById(BANNER_ID);
    if (!banner) { platzBeobachten(); return; }
    var reihe = banner.querySelector('.shopify-pc__banner__btns');
    var wahl = document.getElementById(KNOPF_WAHL_ID);
    if (reihe && wahl && wahl.parentNode === reihe) {
      if (reihe.lastElementChild !== wahl) { reihe.appendChild(wahl); }
      if (!banner.classList.contains('rs-banner-geordnet')) { banner.classList.add('rs-banner-geordnet'); }
    }
    // Ohne Titel im Admin baut Shopify kein Titel-Element; aria-labelledby zeigt dann ins Leere
    var ohneTitel = !document.getElementById(BANNER_TITEL_ID);
    // Ladezeit 01.10.2026: Klasse für rs-cookie.css (Text neben dem Topf) statt :not(:has(#...-title)) > *
    if (ohneTitel !== banner.classList.contains('rs-banner-ohne-titel')) {
      if (ohneTitel) { banner.classList.add('rs-banner-ohne-titel'); } else { banner.classList.remove('rs-banner-ohne-titel'); }
    }
    if (ohneTitel) {
      var deutsch = (document.documentElement.lang || 'de').toLowerCase().indexOf('de') === 0;
      var name = deutsch ? 'Cookie-Zustimmung' : 'Cookie consent';
      if (banner.hasAttribute('aria-labelledby')) { banner.removeAttribute('aria-labelledby'); }
      if (banner.getAttribute('aria-label') !== name) { banner.setAttribute('aria-label', name); }
    }
    // Bannertext als Beschreibung des alertdialog (Muster der ARIA Authoring Practices)
    var text = banner.querySelector('.shopify-pc__banner__body p');
    if (text) {
      if (!text.id) { text.id = 'rs-banner-text'; }
      if (banner.getAttribute('aria-describedby') !== text.id) { banner.setAttribute('aria-describedby', text.id); }
    }
    // Abschnitt 5: am Ende, damit die Anordnung oben auch dann steht, wenn die Messung scheitert
    platzBeobachten();
  }

  function bannerBeobachten() {
    bannerOrdnen();
    if (!window.MutationObserver || !document.body) { return; }
    new MutationObserver(bannerOrdnen).observe(document.body, { childList: true });
  }

  if (document.body) {
    bannerBeobachten();
  } else {
    document.addEventListener('DOMContentLoaded', bannerBeobachten, { once: true });
  }

  // Erster Tab: Shopify lenkt nach dem Einblenden den ersten Tab einmalig per ID auf Praeferenzen
  // (keydown an window). Steht Praeferenzen hinten, liefe der naechste Tab aus dem Banner hinaus. Ein
  // normaler Tab von ausserhalb landet nie direkt auf Praeferenzen (der Banner steht vor allem anderen,
  // zuerst kommt der Link); kommt der Fokus dort an, war es dieser Sprung, und er geht auf Akzeptieren.
  // Geprueft wird nach dem Ereignis, damit Shopifys Listener laufen und sich entfernen kann.
  // Ladezeit Runde 3 (12.10.2026): Bis hierher tut dasselbe das fruehe Skript in snippets/rs-consent.liquid; es hoert auf,
  // sobald window.rsEinwilligung steht (oben gesetzt, also vor diesem Hoerer).
  window.addEventListener('keydown', function (e) {
    if ((e.key !== 'Tab' && e.code !== 'Tab') || e.shiftKey) { return; }
    var banner = document.getElementById(BANNER_ID);
    if (!banner || banner.contains(document.activeElement)) { return; }
    setTimeout(function () {
      var wahl = document.getElementById(KNOPF_WAHL_ID);
      var ja = document.getElementById(KNOPF_JA_ID);
      if (wahl && ja && document.activeElement === wahl && wahl.parentNode &&
          wahl.parentNode.lastElementChild === wahl) {
        ja.focus();
      }
    }, 0);
  }, true);

  // 6. Klick auf „Akzeptieren“ oder „Alle akzeptieren“ sofort anwenden (03.10.2026, Akte
  //    docs/resade/lpv-quote-2026-10-03.md). Shopify meldet visitorConsentCollected erst nach der Antwort auf seinen
  //    POST an /api/unstable/graphql.json; bis dahin galt die Wahl eine Serverrunde lang nicht. Beide Knöpfe erteilen
  //    Marketing, Statistik und Präferenzen, der Klick ist die Einwilligung (Art. 4 Nr. 11 DSGVO; DSK OH Digitale
  //    Dienste 1.2, Rn. 122). Deshalb gilt der Stand ab dem Klick: Consent Mode, Warteliste (Klaviyo) und
  //    rs:einwilligung. Den Container startet der Klick seit 05.10.2026 nicht mehr, er läuft schon (Abschnitt 0); die
  //    Vorab-Verbindungen zu Meta setzt der Kopf beim Seitenstart, die früheren im Klick sind entfallen.
  //    Ablehnen, Präferenzen und „Meine Auswahl speichern“ bleiben beim Weg über Shopifys Ereignis.
  //    Bubble-Phase am document: Der Hörer läuft im selben Task direkt nach Shopifys Hörer am Knopf, der den POST schon
  //    gestartet hat, und gar nicht, wenn ein anderes Skript den Klick vorher stoppt (facets.js verschluckt nach dem
  //    Preisregler einen Klick in der Capture-Phase). In Shopifys Banner-Vorschau (?preview_privacy_banner=1) speichert
  //    Shopify nichts, dort bleibt es beim alten Weg. Shopify speichert die Wahl im selben Klick (Cookie
  //    _tracking_consent), darauf stützt sich der Nachweis nach Art. 7 Abs. 1 DSGVO; nur dann kommt sein Ereignis
  //    danach mit demselben Stand. Scheitert das Speichern, gilt der Klick nur für diese Seite, Shopify blendet den
  //    Banner trotzdem aus (Restrisiko, Akte).
  var KNOPF_ALLE_JA_ID = 'shopify-pc__prefs__header-accept';

  // wie Shopifys eigene Prüfung in storefront-banner.js: das erste preview_privacy_banner im Query-String zählt
  function bannerVorschau() {
    var treffer = /[?&]preview_privacy_banner=([^&#]*)/.exec((window.location && window.location.search) || '');
    return Boolean(treffer) && treffer[1] === '1';
  }

  document.addEventListener('click', function (e) {
    var ziel = e.target && e.target.closest ? e.target.closest('#' + KNOPF_JA_ID + ', #' + KNOPF_ALLE_JA_ID) : null;
    if (!ziel) { return; }
    try { if (bannerVorschau()) { return; } } catch (fehler) { return; }
    anwenden(true, true, true, true);
  });
})();
